import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
export const upgradeCreate = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UpgradeCreate), {
        credentials: "include",
        headers,
        json: {
            upgrades: body,
        },
    }).json();
};
export const upgradeList = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UpgradeList), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const upgradeToggle = async (upgradeId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UpgradeToggle, { upgradeId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
